import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var title = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";text-align:center;", designTokenFonts.displaySmall);
export var body = /*#__PURE__*/css("display:block;padding:24px;color:", colors.neutral.heavy.default, ";");
export var section = {
  name: "1o5g810",
  styles: "&:not(:last-of-type){margin-bottom:24px;}"
};
export var heading = /*#__PURE__*/css(designTokenFonts.subheading);
export var text = /*#__PURE__*/css(designTokenFonts.body);
export var textBold = /*#__PURE__*/css(designTokenFonts.bodyBold);
export var link = /*#__PURE__*/css("display:flex;align-items:center;gap:8px;align-self:stretch;color:", colors.interactive.base.default, ";text-decoration:none;");
export var linkIcon = {
  name: "540lu8",
  styles: "width:14px;height:14px;"
};
export var listItem = /*#__PURE__*/css("display:flex;align-items:flex-start;gap:12px;align-self:stretch;margin-top:16px;", designTokenFonts.body);